export default __webpack_public_path__ + "static/media/footer-bg-map.082a3981.png";